import {
  CommandEntityTypeEnum,
  type STORAGE_KEY_COMMAND_HISTORY_TYPE,
  STORAGE_KEY_COMMAND_INIT_VALUE,
} from '@/components/Commander';
import Modal from '@/components/Modal';
import PosButton from '@/components/PosButton';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { playSoundClick } from '@/utils/sound';
import { STORAGE_KEY_COMMAND_HISTORY } from '@/utils/storage';
import { Style_Display_None } from '@/utils/uiHelper';
import { HistoryOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { Avatar, List, Tabs } from 'antd';
import { useContext, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { fastActionBtnProps } from '../../utils/ui';

const CommandHistoryList = ({
  type,
}: // items,
{
  type: CommandEntityTypeEnum;
  // items: STORAGE_KEY_COMMAND_HISTORY_TYPE[string];
}) => {
  const [commandHistory] = useLocalStorage<STORAGE_KEY_COMMAND_HISTORY_TYPE>(
    STORAGE_KEY_COMMAND_HISTORY,
    STORAGE_KEY_COMMAND_INIT_VALUE
  );
  const [, , { showUserModal, showOrderModal }] = useContext(BaseInfoContext);
  const items = commandHistory[type];

  return (
    <List
      dataSource={items}
      pagination={{
        pageSize: 5,
      }}
      renderItem={item => (
        <List.Item
          actions={[
            <PosButton
              icon={<PlayCircleOutlined />}
              key="replay"
              onClick={() => {
                const props = Object.assign({}, item._props);
                if (type === CommandEntityTypeEnum.ORDER) {
                  showOrderModal(props);
                } else if (type === CommandEntityTypeEnum.USER) {
                  showUserModal(props);
                }
              }}>
              重放
            </PosButton>,
          ]}>
          <List.Item.Meta
            avatar={item.img ? <Avatar src={item.img} /> : undefined}
            title={item.title}
            description={item.subTitle}
          />
        </List.Item>
      )}></List>
  );
};

export default () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <PosButton
        {...fastActionBtnProps}
        icon={<HistoryOutlined />}
        onClick={() => {
          setModalOpen(true);
        }}>
        历史
      </PosButton>
      {modalOpen ? (
        <Modal
          title={
            <>
              <HistoryOutlined /> 查询历史
            </>
          }
          onCancel={() => {
            setModalOpen(false);
          }}
          onOk={() => {
            setModalOpen(false);
          }}
          maskClosable
          cancelButtonProps={Style_Display_None}
          okText={<>关闭</>}
          width={750}
          open={modalOpen}>
          <Tabs
            size="large"
            tabPosition="left"
            onChange={playSoundClick}
            items={[
              {
                key: `${CommandEntityTypeEnum.USER}`,
                label: '用户',
                children: <CommandHistoryList type={CommandEntityTypeEnum.USER} />,
              },
              {
                key: `${CommandEntityTypeEnum.ORDER}`,
                label: '订单',
                children: <CommandHistoryList type={CommandEntityTypeEnum.ORDER} />,
              },
            ]}
          />
        </Modal>
      ) : null}
    </>
  );
};
